export default function Testimoni() {
  return (
    <>
      <section className="text-gray-600 body-font scroll-animate">
        <div className="container px-5 py-24 mx-auto">

          <div className="mb-20 text-center scroll-animate">
            <h1 className="mb-4 text-2xl font-medium text-gray-900 sm:text-3xl title-font">
              Apa kata siswa?
            </h1>
            <p className="mx-auto text-base leading-relaxed xl:w-2/4 lg:w-3/4 text-gray-500">
              Kami telah melakukan survei kepuasan kepada para siswa sebagai penerima
              program Makanan Bergizi Gratis untuk menilai kualitas dan manfaat hidangan
              yang disajikan.
            </p>
            <div className="flex justify-center mt-6">
              <div className="inline-flex w-16 h-1 bg-indigo-500 rounded-full"></div>
            </div>
          </div>

          <div className="flex flex-wrap -mx-4 -mt-4 -mb-10 space-y-6 sm:-m-4 md:space-y-0">
            <div className="flex flex-col items-center p-4 text-center md:w-1/3 scroll-animate">
              <div className="inline-flex items-center justify-center flex-shrink-0 w-20 h-20 mb-5 text-indigo-500 bg-indigo-100 rounded-full">
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                  strokeWidth="2" className="w-10 h-10" viewBox="0 0 24 24">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <div className="flex-grow">
                <h2 className="mb-3 text-lg font-medium text-gray-900 title-font">
                  M. Syawal Arif B.
                </h2>
                <p className="text-base leading-relaxed">
                  “Sejak ada program MBG di sekolah, saya merasa lebih fokus dan
                  bersemangat mengikuti pelajaran. Makanannya bergizi, rasanya enak,
                  dan porsinya pas untuk menjaga energi sampai jam terakhir.”
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center p-4 text-center md:w-1/3 scroll-animate">
              <div className="inline-flex items-center justify-center flex-shrink-0 w-20 h-20 mb-5 text-indigo-500 bg-indigo-100 rounded-full">
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                  strokeWidth="2" className="w-10 h-10" viewBox="0 0 24 24">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <div className="flex-grow">
                <h2 className="mb-3 text-lg font-medium text-gray-900 title-font">
                  Muhammad Ihsan
                </h2>
                <p className="text-base leading-relaxed">
                  “Makanan dari MBG membantu saya tetap bertenaga dan tidak cepat lelah.
                  Setiap harinya menunya berbeda, jadi nggak bosan. Sekarang saya bisa
                  belajar dengan lebih konsentrasi dan semangat.”
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center p-4 text-center md:w-1/3 scroll-animate">
              <div className="inline-flex items-center justify-center flex-shrink-0 w-20 h-20 mb-5 text-indigo-500 bg-indigo-100 rounded-full">
                <svg fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"
                  strokeWidth="2" className="w-10 h-10" viewBox="0 0 24 24">
                  <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"></path>
                  <circle cx="12" cy="7" r="4"></circle>
                </svg>
              </div>
              <div className="flex-grow">
                <h2 className="mb-3 text-lg font-medium text-gray-900 title-font">
                  Rendy M. Tohir
                </h2>
                <p className="text-base leading-relaxed">
                  “Program MBG benar-benar bermanfaat bagi kami. Selain membuat perut kenyang,
                  kandungan gizinya membantu menjaga fokus, daya tahan tubuh, dan semangat belajar."
                </p>
              </div>
            </div>

          </div>
        </div>
      </section>
    </>
  );
}
